<template>
  <div class="type-r round-titles-shown">
    <div
      class="robins d-flex flex-column"
      v-for="stage in competitionIsOngoing
        ? competition.stages.filter(
            stage => stage.isCurrent && stage.category === category
          )
        : competition.stages"
    >
      <div class="round-titles round-titles-winners d-block">
        <div class="round-title">
          <span>Tur</span>
        </div>
        <div v-if="spec === 'twoway'" class="round-title">
          <span>Retur</span>
        </div>
      </div>

      <!-- <div
        v-if="spec === 'oneway'"
        v-for="round in competitionIsOngoing ? rounds : stage.rounds"
        :key="round._id"
        class="round"
      ></div> -->
      <div v-if="spec === 'oneway'" class="round">
        <draggable
          v-if="
            matches
              .filter(match => {
                let checker = competition.stages.find(
                  stage =>
                    stage.isChosen && stage.category === $route.params.cat
                );
                if (checker) return match.stage._id === checker._id;
              })
              .every(match => !match._id)
          "
          :list="matches"
          group="rounds"
          tag="ul"
          v-bind="dragOptions"
          @change="log"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <transition-group type="transition" name="flip-list">
            <li
              v-for="(match, index) in matches"
              id="game-1-1"
              class="game list-no-style"
              :key="match.home_team._id + match.away_team._id + match.round._id"
              :class="{ 'game-completed': match.isFinished }"
            >
              <div class="match-date-time">
                <span>{{
                  match.start_date
                    ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                    : ""
                }}</span
                ><span v-if="match.isCancelled" class="cancel">{{
                  $t("competition.cancelled")
                }}</span>
              </div>
              <div class="slot slot-top" :class="getSlot('top', match)" pid="1">
                <div class="slot-seed">
                  {{ getTeamNumber(match.home_team) }}
                </div>
                <div class="slot-name">{{ match.home_team.name }}</div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.home_players, match, match.home_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>

              <div
                class="slot slot-bot"
                :class="getSlot('bottom', match)"
                pid="2"
              >
                <div class="slot-seed">
                  {{ getTeamNumber(match.away_team) }}
                </div>
                <div class="slot-name">{{ match.away_team.name }}</div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.away_players, match, match.away_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
            </li>
          </transition-group>
        </draggable>
        <div
          v-else
          v-for="(match, index) in matches
            .filter(
              match =>
                match.stage._id ===
                competition.stages.find(
                  stage => stage.isChosen && stage.category === category
                )._id
            )
            .sort((a, b) => {
              return new Date(a.created_at) - new Date(b.created_at);
            })"
          @click="() => checkModal(match)"
          id="game-1-1"
          class="game"
          :class="{ 'game-completed': match.isFinished }"
        >
          <div class="match-date-time">
            <span>{{
              match.start_date
                ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                : ""
            }}</span
            ><span v-if="match.isCancelled" class="cancel">{{
              $t("competition.cancelled")
            }}</span>
          </div>
          <div class="slot slot-top" :class="getSlot('top', match)" pid="1">
            <div class="slot-seed">{{ getTeamNumber(match.home_team) }}</div>
            <div class="slot-name">{{ match.home_team.name }}</div>
            <div class="slot-score">
              <div class="slot-datetime-val slot-time-val"></div>
              <div class="slot-datetime-val slot-date-val"></div>
              <div class="slot-score-val">
                {{ getPoints(match.home_players, match, match.home_team) }}
              </div>
              <div class="slot-check">
                <div class="icon icon-check"></div>
              </div>
            </div>
          </div>

          <div class="slot slot-bot" :class="getSlot('bottom', match)" pid="2">
            <div class="slot-seed">{{ getTeamNumber(match.away_team) }}</div>
            <div class="slot-name">{{ match.away_team.name }}</div>
            <div class="slot-score">
              <div class="slot-datetime-val slot-time-val"></div>
              <div class="slot-datetime-val slot-loct-val"></div>
              <div class="slot-score-val">
                {{ getPoints(match.away_players, match, match.away_team) }}
              </div>
              <div class="slot-check">
                <div class="icon icon-check"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="spec === 'twoway'" class="round twoway-twoway-twoway d-flex">
        <div class="d-flex flex-column">
          <draggable
            v-if="
              matches
                .filter(match => {
                  let check = competition.stages.find(
                    stage =>
                      stage.isChosen && stage.category === $route.params.cat
                  );
                  if (check) return match.stage._id === check._id;
                })
                .every(match => !match._id)
            "
            :list="dragTur"
            group="tur"
            tag="ul"
            v-bind="dragOptions"
            @change="log"
            @start="isDragging = true"
            @end="isDragging = false"
          >
            <transition-group type="transition" name="flip-list">
              <li
                v-for="(match, index) in dragTur"
                :id="'game-2-' + ++index"
                :key="
                  match.home_team._id + match.away_team._id + match.round._id
                "
                class="game game-completed list-no-style oooooooooo"
              >
                <div class="match-date-time">
                  <span>{{
                    match.start_date
                      ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                      : ""
                  }}</span
                  ><span v-if="match.isCancelled" class="cancel">{{
                    $t("competition.cancelled")
                  }}</span>
                </div>
                <div
                  class="slot slot-top"
                  :class="getSlot('top', match)"
                  pid="1"
                >
                  <div class="slot-seed">
                    {{ getTeamNumber(match.home_team) }}
                  </div>
                  <div class="slot-name">{{ match.home_team.name }}</div>
                  <div class="slot-score">
                    <div class="slot-datetime-val slot-time-val"></div>
                    <div class="slot-datetime-val slot-date-val"></div>
                    <div class="slot-score-val">
                      {{
                        getPoints(match.home_players, match, match.home_team)
                      }}
                    </div>
                    <div class="slot-check">
                      <div class="icon icon-check"></div>
                    </div>
                  </div>
                </div>

                <div
                  class="slot slot-bot "
                  :class="getSlot('bottom', match)"
                  pid="2"
                >
                  <div class="slot-seed">
                    {{ getTeamNumber(match.away_team) }}
                  </div>
                  <div class="slot-name">{{ match.away_team.name }}</div>
                  <div class="slot-score">
                    <div class="slot-datetime-val slot-time-val"></div>
                    <div class="slot-datetime-val slot-loct-val"></div>
                    <div class="slot-score-val">
                      {{
                        getPoints(match.away_players, match, match.away_team)
                      }}
                    </div>
                    <div class="slot-check">
                      <div class="icon icon-check"></div>
                    </div>
                  </div>
                </div>
              </li>
            </transition-group>
          </draggable>

          <div
            v-else
            v-for="(match, index) in dragTur"
            :id="'game-2-' + ++index"
            class="game game-completed oooooooooo"
            @click="() => checkModal(match)"
          >
            <div class="match-date-time">
              <span>{{
                match.start_date
                  ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                  : ""
              }}</span
              ><span v-if="match.isCancelled" class="cancel">{{
                $t("competition.cancelled")
              }}</span>
            </div>
            <div class="slot slot-top" :class="getSlot('top', match)" pid="1">
              <div class="slot-seed">
                {{ getTeamNumber(match.home_team) }}
              </div>
              <div class="slot-name">{{ match.home_team.name }}</div>
              <div class="slot-score">
                <div class="slot-datetime-val slot-time-val"></div>
                <div class="slot-datetime-val slot-date-val"></div>
                <div class="slot-score-val">
                  {{ getPoints(match.home_players, match, match.home_team) }}
                </div>
                <div class="slot-check">
                  <div class="icon icon-check"></div>
                </div>
              </div>
            </div>
            <div
              class="slot slot-bot "
              :class="getSlot('bottom', match)"
              pid="2"
            >
              <div class="slot-seed">
                {{ getTeamNumber(match.away_team) }}
              </div>
              <div class="slot-name">{{ match.away_team.name }}</div>
              <div class="slot-score">
                <div class="slot-datetime-val slot-time-val"></div>
                <div class="slot-datetime-val slot-loct-val"></div>
                <div class="slot-score-val">
                  {{ getPoints(match.away_players, match, match.away_team) }}
                </div>
                <div class="slot-check">
                  <div class="icon icon-check"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column">
          <draggable
            v-if="
              matches
                .filter(match => {
                  let check = competition.stages.find(
                    stage =>
                      stage.isChosen && stage.category === $route.params.cat
                  );
                  if (check) return match.stage._id === check._id;
                })
                .every(match => !match._id)
            "
            :list="dragRetur"
            group="retur"
            tag="ul"
            v-bind="dragOptions"
            @change="log"
            @start="isDragging = true"
            @end="isDragging = false"
          >
            <transition-group type="transition" name="flip-list">
              <li
                v-for="(match, index) in dragRetur"
                :id="'game-2-' + ++index"
                :key="
                  match.home_team._id + match.away_team._id + match.round._id
                "
                class="game game-completed list-no-style"
              >
                <div class="match-date-time">
                  <span>{{
                    match.start_date
                      ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                      : ""
                  }}</span
                  ><span v-if="match.isCancelled" class="cancel">{{
                    $t("competition.cancelled")
                  }}</span>
                </div>
                <div
                  class="slot slot-top"
                  :class="getSlot('top', match)"
                  pid="1"
                >
                  <div class="slot-seed">
                    {{ getTeamNumber(match.home_team) }}
                  </div>
                  <div class="slot-name">{{ match.home_team.name }}</div>
                  <div class="slot-score">
                    <div class="slot-datetime-val slot-time-val"></div>
                    <div class="slot-datetime-val slot-date-val"></div>
                    <div class="slot-score-val">
                      {{
                        getPoints(match.home_players, match, match.home_team)
                      }}
                    </div>
                    <div class="slot-check">
                      <div class="icon icon-check"></div>
                    </div>
                  </div>
                </div>

                <div
                  class="slot slot-bot "
                  :class="getSlot('bottom', match)"
                  pid="2"
                >
                  <div class="slot-seed">
                    {{ getTeamNumber(match.away_team) }}
                  </div>
                  <div class="slot-name">{{ match.away_team.name }}</div>
                  <div class="slot-score">
                    <div class="slot-datetime-val slot-time-val"></div>
                    <div class="slot-datetime-val slot-loct-val"></div>
                    <div class="slot-score-val">
                      {{
                        getPoints(match.away_players, match, match.away_team)
                      }}
                    </div>
                    <div class="slot-check">
                      <div class="icon icon-check"></div>
                    </div>
                  </div>
                </div>
              </li>
            </transition-group>
          </draggable>

          <div
            v-else
            v-for="(match, index) in dragRetur"
            :id="'game-2-' + ++index"
            class="game game-completed"
            @click="() => checkModal(match)"
          >
            <div class="match-date-time">
              <span>{{
                match.start_date
                  ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                  : ""
              }}</span
              ><span v-if="match.isCancelled" class="cancel">{{
                $t("competition.cancelled")
              }}</span>
            </div>
            <div class="slot slot-top" :class="getSlot('top', match)" pid="1">
              <div class="slot-seed">
                {{ getTeamNumber(match.home_team) }}
              </div>
              <div class="slot-name">{{ match.home_team.name }}</div>
              <div class="slot-score">
                <div class="slot-datetime-val slot-time-val"></div>
                <div class="slot-datetime-val slot-date-val"></div>
                <div class="slot-score-val">
                  {{ getPoints(match.home_players, match, match.home_team) }}
                </div>
                <div class="slot-check">
                  <div class="icon icon-check"></div>
                </div>
              </div>
            </div>

            <div
              class="slot slot-bot "
              :class="getSlot('bottom', match)"
              pid="2"
            >
              <div class="slot-seed">
                {{ getTeamNumber(match.away_team) }}
              </div>
              <div class="slot-name">{{ match.away_team.name }}</div>
              <div class="slot-score">
                <div class="slot-datetime-val slot-time-val"></div>
                <div class="slot-datetime-val slot-loct-val"></div>
                <div class="slot-score-val">
                  {{ getPoints(match.away_players, match, match.away_team) }}
                </div>
                <div class="slot-check">
                  <div class="icon icon-check"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <MatchCircuitModal v-if="circuitModal" :match="selectedMatch" :competition="competition" @close="(e) => close(e)" /> -->
  </div>
</template>
<script>
import bracketsMixin from "./bracketsMixin";
// import MatchCircuitModal from "../schemes/formats/MatchCircuitModal.vue";
import draggable from "vuedraggable";

export default {
  name: "BracketCircuit",
  components: { draggable },
  data() {
    return bracketsMixin;
  },
  methods: {
    log(e) {
      console.log(e);
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  async created() {
    this.innerLoading = true;
    this.category = this.$route.params.cat;
    this.competitionIsOngoing = Boolean(
      this.competition.stages.filter(
        stage =>
          (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
          stage.category === this.category
      ).length
    );
    if (this.competitionIsOngoing) {
      this.saveRounds(
        this.competition.stages.find(
          stage =>
            (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
            stage.category === this.category
        ).rounds
      );
    }

    if (this.competitionIsOngoing) {
      await this.getCurrentTeams();
      if (
        !this.rounds.filter(round => round.category === this.$route.params.cat)
          .length
      ) {
        await this.generateRounds();
      }
      if (!this.isVisible)
        await this.getAllMatches(
          this.competition.stages.filter(
            stage =>
              (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
              stage.category === this.category
          )
        );
      if (this.type === "circuit") {
        if (this.spec === "oneway") {
          this.checkForMatches();
        } else if (this.spec === "twoway") {
          this.checkForPairMatches();
        }
      }
      if (
        this.matches
          .filter(
            match =>
              match.stage._id ===
              this.competition.stages.find(
                stage => stage.isChosen && stage.category === this.category
              )._id
          )
          .every(match => !match._id)
      ) {
        console.log(this.matches);
        this.dragTur = this.matches
          .sort((a, b) => {
            return new Date(a.created_at) - new Date(b.created_at);
          })
          .filter((_match, ind) => (ind + 1) % 2 !== 0);
        this.dragRetur = this.matches
          .sort((a, b) => {
            return new Date(a.created_at) - new Date(b.created_at);
          })
          .filter((_match, ind) => (ind + 1) % 2 === 0);
        console.log({ tur: this.dragTur, retur: this.dragRetur });
      } else if (
        !this.matches
          .filter(
            match =>
              match.stage._id ===
              this.competition.stages.find(
                stage => stage.isChosen && stage.category === this.category
              )._id
          )
          .every(match => !match._id)
      ) {
        console.log(
          this.matches
            .filter(
              (match, ind) =>
                match.stage._id ===
                this.competition.stages.find(
                  stage =>
                    stage.isChosen && stage.category === this.$route.params.cat
                )._id
            )
            .sort((a, b) => {
              return new Date(a.created_at) - new Date(b.created_at);
            })
            .map(match => {
              return { home: match.home_team.name, away: match.away_team.name };
            })
        );
        this.dragTur = this.matches
          .filter(
            (match, ind) =>
              match.stage._id ===
              this.competition.stages.find(
                stage =>
                  stage.isChosen && stage.category === this.$route.params.cat
              )._id
          )
          .sort((a, b) => {
            return new Date(a.created_at) - new Date(b.created_at);
          })
          .slice(
            0,
            this.matches.filter(
              (match, ind) =>
                match.stage._id ===
                this.competition.stages.find(
                  stage =>
                    stage.isChosen && stage.category === this.$route.params.cat
                )._id
            ).length / 2
          );
        console.log({ dragTur: this.dragTur });
        this.dragRetur = this.matches
          .filter(
            (match, ind) =>
              match.stage._id ===
              this.competition.stages.find(
                stage =>
                  stage.isChosen && stage.category === this.$route.params.cat
              )._id
          )
          .sort((a, b) => {
            return new Date(a.created_at) - new Date(b.created_at);
          })
          .slice(
            this.matches.filter(
              (match, ind) =>
                match.stage._id ===
                this.competition.stages.find(
                  stage =>
                    stage.isChosen && stage.category === this.$route.params.cat
                )._id
            ).length / 2
          );
        console.log({ dragRetur: this.dragRetur });
      }
      this.checkFinishCompetition();
      this.turnOnInbetweenStagesVisibility();
    } else {
      // await this.getAllMatches(this.competition.stages)
      if (this.type === "circuit") {
        if (this.spec === "oneway") {
          this.checkForMatches();
        } else if (this.spec === "twoway") {
          this.checkForPairMatches();
        }
      }
      this.checkFinishCompetition();
    }
    if (
      this.competition.stages.find(
        stage =>
          stage.isChosen && stage.isCurrent && stage.category === this.category
      )
    )
      await this.checkTeamIntegrity();
    this.innerLoading = false;
  }
};
</script>

<style scoped>
@import "./brackets.css";
.flip-list-move {
  transition: transform 0.5s;
}
.list-no-style {
  list-style-type: none;
}
ul {
  padding: 0;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.match-date-time {
  color: #ffef00;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 18px;
  padding: 0 10px;
  font-size: 12px;
  text-shadow: 1px 1px #000;
}

.match-date-time span.cancel {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/brackets/Circuit.vue